import { Validators } from '@angular/forms';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';

export const otherValidationSet: ValidationPair = {
  children: {
    shared: {
      children: {
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
      },
    },
  },
};
